import axios from "axios"

//apply base url for axios
const API_URL = process.env.REACT_APP_API_URL

const axiosApi = axios.create({
  baseURL: API_URL,
})

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

axiosApi.defaults.withCredentials = true
axiosApi.defaults.credentials = "include"

// A read that never answers (e.g. an API stuck on its session store) must end
// in an error the page can show, not an endless spinner. The bound is well above
// the slowest PROD read (~22 s); writes and exports keep no bound, because their
// outcome is uncertain once sent and they carry their own deadlines.
export const DEFAULT_READ_TIMEOUT_MS = 60000

export async function get(url, config = {}) {
  return await axiosApi.get(url, { timeout: DEFAULT_READ_TIMEOUT_MS, ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi({
    method: "POST",
    url,
    data,
    ...config,
  }).then(response => response.data)
}

export async function postExport(url, data, config = {}) {
  return axiosApi({
    method: "POST",
    url,
    data,
    ...config,
  }).then(response => response)
}

export async function getExport(url, config = {}) {
  return axiosApi({
    method: "GET",
    url,
    ...config,
  }).then(response => response)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function patch(url, data, config = {}) {
  return axiosApi
    .patch(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, data, config = {}) {
  return axiosApi({
    method: "DELETE",
    url,
    data,
    ...config,
  }).then(response => response.data)
}
